import {
  apiAddScanSendByteWalletAddress,
  apiDeleteSendByteWalletAddress,
  apiGetSendByteWalletAddress,
} from "@lib/api/walletSendByte";
import { UseQueriesProps } from "@lib/types/General";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

export const useSendByteWalletAddressQueries = (props: UseQueriesProps) => {
  const { queryKey, params, id, messages, enabled = true } = props;
  const queryKeys = queryKey || [
    "sendbyte-wallet-address",
    params ? JSON.stringify(params) : id,
  ];
  const queryClient = useQueryClient();

  const sendByteWalletAddressQuery = useQuery({
    queryFn: () => apiGetSendByteWalletAddress(params),
    queryKey: queryKeys,
    enabled: !!params && !!enabled,
  });

  const addScanSendByteWalletAddressMutation = useMutation({
    mutationFn: apiAddScanSendByteWalletAddress,
    mutationKey: queryKeys,
    onSuccess() {
      queryClient.resetQueries({
        predicate: (query) => {
          const key = query.queryKey;
          return JSON.stringify(key).includes("sendbyte-wallet-address");
        },
      });
    },
  });

  const deleteSendByteWalletAddressMutation = useMutation({
    mutationFn: apiDeleteSendByteWalletAddress,
    onSuccess() {
      toast.success(
        (messages["common.deletedMessage"] as string).replace(
          "{name}",
          messages["common.walletAddress"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });

      queryClient.resetQueries({
        predicate: (query) => {
          const key = query.queryKey;
          return JSON.stringify(key).includes("sendbyte-wallet-address");
        },
      });
    },
  });

  return {
    sendByteWalletAddressQuery,
    deleteSendByteWalletAddressMutation,
    addScanSendByteWalletAddressMutation,
  };
};
